<template>
  <el-form :model="sku" label-width="160px" :loading="loading">
    <el-form-item label="名称" required>
      <el-input placeholder="商品或者服务或者课程的名称" v-model="sku.title"/>
    </el-form-item>
    <el-form-item label="商品服务类型" required>
      <el-select v-model="sku.type" placeholder="请选择类型">
        <el-option
          v-for="item in skuTypes"
          :key="item.id"
          :label="item.text"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="单位">
      <el-input placeholder="元,或者课时" v-model="sku.unit"/>
    </el-form-item>
    <el-form-item label="商品服务有效期" required>
      <el-select v-model="sku.shelfLifeType" placeholder="请选择有效期单位">
        <el-option
          v-for="item in shelfLifeType"
          :key="item.id"
          :label="item.text"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="有效期数量">
      <el-input placeholder="数量,如果选择天 XX天 选择年 XX年" v-model="sku.shelfLifeCount"/>
    </el-form-item>
    <el-form-item label="备注">
      <el-input type="textarea" v-model="sku.remark" multiline/>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submitSaveAction">确 定</el-button>
      <el-button @click="close">取 消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {add, update} from './skuApi'

export default {
  name: 'addSku',
  data () {
    return {
      loading: false,
      sku: {
        title: '',
        remark: '',
        type: null,
        shelfLifeCount: '',
        shelfLifeType: null
      },
      skuTypes: [
        {
          id: 1,
          text: '储值卡'
        },
        {
          id: 2,
          text: '课时'
        },
        {
          id: 3,
          text: '次卡'
        }
      ],
      shelfLifeType: [
        {
          id: 1,
          text: '天'
        },
        {
          id: 2,
          text: '星期'
        },
        {
          id: 3,
          text: '月'
        },
        {
          id: 4,
          text: '年'
        }
      ],
      addOrEdit: true
    }
  },
  props: {
    data: {
      title: '',
      remark: '',
      unit: '',
      skuId: ''
    }
  },
  created () {
    if (this.data !== undefined && this.data !== null) {
      const copy = JSON.parse(JSON.stringify(this.data))
      const { skuId } = copy
      this.addOrEdit = skuId === undefined
      this.sku = copy
    }
  },
  watch: {
    data (d) {
      const copy = JSON.parse(JSON.stringify(d))
      const { skuId } = copy
      this.addOrEdit = skuId === undefined
      this.sku = copy
    }
  },
  methods: {
    submitSaveAction () {
      if (this.addOrEdit === true) {
        this.submitAddAction()
      } else {
        this.submitUpdateSku()
      }
    },
    submitAddAction () {
      const title = this.sku.title.trim()
      if (title.length === 0) {
        this.$message.error('姓名不能为空')
        return
      }
      this.loading = true
      add(this.sku).then(rsp => {
        this.loading = false
        const {code, message} = rsp
        if (code === 0) {
          this.$message.success('添加成功')
          this.$emit('success')
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    submitUpdateSku () {
      this.loading = true
      update(this.sku).catch(() => {
        this.loading = false
      }).then((rsp) => {
        const {code, message} = rsp
        if (code === 0) {
          this.$message.success('修改成功')
          this.$emit('success')
        } else {
          this.$message.error(message)
        }
      })
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sku/addSku.vue